import { Component, OnInit } from '@angular/core';
import { IdleDetectionService } from './services/idle-detection.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  /**
   * Constructor
   */
  constructor(private idleDetectionService: IdleDetectionService) {}

  /**
   * On init
   */
  ngOnInit(): void {
    this.idleDetectionService.trackUserActivity();
  }
}
